import { render, staticRenderFns } from "./public_review_settings.vue?vue&type=template&id=7807c142&"
import script from "./public_review_settings.vue?vue&type=script&lang=js&"
export * from "./public_review_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports